<template>
  <div>
      <div class="component-container">
          <h2>Índice de Inflación Interanual</h2> 

          <p>
            El Índice de Inflación Interanual es una medida económica que calcula el cambio porcentual en el nivel de precios de bienes y servicios durante un período de un año completo en comparación con el mismo período del año anterior.
          </p>

          <p>
            Este índice proporciona una visión de la tasa de inflación a largo plazo en una economía, mostrando cómo los precios han variado en un año calendario. 
          </p>
      </div>

      <b-overlay :show="showOverlay" rounded="sm">
        <div v-if="screenWidth > 768">
            <Bar
            id="barChart"
            ref="barChart"
            v-if="chartLoaded"
            :options="chartOptions"
            :data="chartData"
            :style="styles" />
        </div>
        <div v-else>
            <Table />
        </div>
    </b-overlay>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import zoomPlugin from 'chartjs-plugin-zoom';
import Table from '@/components/Misc/CircularMenu/RightComponent/Table.vue';
import yearOnYearInflationIndexesMock from '@/assets/mocks/yearOnYearInflationIndexesMock.json';
import API_ROUTES from '@/api/routes';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  zoomPlugin 
);

export default {
  name: "RightComponent",
  components: { Bar, Table },
  computed: {
      styles() {
          return {
              color: "#8C08B9",
              position: "relative",
          };
      },
  },
  data() {
      return {
          screenWidth: window.innerWidth,
          showOverlay: false,
          chartLoaded: false,
          yearOnYearInflationIndexes: [],
          chartData: {
              labels: [],
              datasets: [
                  {
                      label: "Índice de Inflación Interanual",
                      data: [],
                      backgroundColor: ["#8C08B9"],
                  },
              ],
          },
          chartOptions: {
              responsive: true,
              scales: {
                  x: {
                      ticks: {
                          color: "black",
                          font: {
                              weight: "bold",
                              size: "14",
                          },
                      },
                  },
                  y: {
                      ticks: {
                          color: "#8C08B9",
                          font: {
                              weight: "bold",
                              size: "14",
                          },
                          callback: function (value) {
                              return value + "%";
                          },
                      },
                      beginAtZero: true,
                  },
              },
              plugins: {
                  legend: {
                      labels: {
                          color: "black",
                          font: {
                              weight: "bold",
                              size: "14",
                          }
                      },
                  },
                  tooltip: {
                      callbacks: {
                          label: function (tooltipItem) {
                              return tooltipItem.raw + "%";
                          },
                      },
                  },
                  zoom: {
                      pan: {
                          enabled: true,
                          mode: 'x',
                      },
                      zoom: {
                          wheel: {
                              enabled: true,
                          },
                          pinch: {
                              enabled: true
                          },
                          mode: 'x',
                          rangeMin: {
                              x: 0
                          },
                          rangeMax: {
                              x: 0
                          }
                      }
                  }
              },
          },
      };
  },
  async mounted() {
      this.updateScreenWidth();
      window.addEventListener('resize', this.updateScreenWidth);
      
      this.chartLoaded = false;

      this.getYearOnYearIndexes();

      // Mock
      //   this.chartData.labels = yearOnYearInflationIndexesMock.data.map(
      //       (item) => item.date
      //   );

      //   this.chartData.datasets[0].data = yearOnYearInflationIndexesMock.data.map(
      //       (item) => item.value
      //   );
  },
  async created() {
      
  },
  
  destroyed() {
      window.removeEventListener('resize', this.updateScreenWidth);
  },

  methods: {
      updateScreenWidth() {
          this.screenWidth = window.innerWidth;
      },

      async getYearOnYearIndexes() {
          this.showOverlay = true;
          this.chartLoaded = false;

          await this.$axios.get(API_ROUTES.GET_INFLATION_INDEXES, {
            params: { inflationIndexType: 2 }})
            .then(res => {
                if (res.data?.data?.errors?.length >= 1) {
                    const errorMessages = res.data.errors.map(error => error.errorMessage);
                    this.showNotification("error", ...errorMessages);
                } else {
                    this.yearOnYearInflationIndexes = res.data.data;
                    
                    this.chartData.labels = this.yearOnYearInflationIndexes.map(
                        (item) => item.date
                    );

                    this.chartData.datasets[0].data = this.yearOnYearInflationIndexes.map(
                        (item) => item.value
                    );

                    this.setZoomToLastThreeMonths();

                    this.chartLoaded = true;
                }
            })
            .catch(e => {
                this.showNotification("error", "No fue posible cargar los datos. Error: " + e);
            })
            .finally(e => {
                this.showOverlay = false;
                this.chartLoaded = true;
            });

          this.showOverlay = false;
      },

      setZoomToLastThreeMonths() {
          const lastThreeMonthsStartIndex = Math.max(this.chartData.labels.length - 3, 0);

          this.chartOptions.scales.x.min = this.chartData.labels[lastThreeMonthsStartIndex];
          this.chartOptions.scales.x.max = this.chartData.labels[this.chartData.labels.length - 1];
      },

      showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
  }
};
</script>